import { PROJECT_TYPES } from './commonProjects';
import { USER_PERMISSIONS } from './userPermissions';
import { ALL_OPTIONS_VALUE } from './common';

export const SIDEBAR_WIDTH = 96;
export const HEADER_HEIGHT = 96;
export const HEADER_HEIGHT_MOBILE = 80;

export const roundedComponentVariants = {
  rounded: 'rounded',
  squared: 'squared',
};

export const componentsSize = {
  small: 'small',
  medium: 'medium',
  large: 'large',
};

export const STATUS_TYPES = {
  ACTIVE: 'Active',
  DRAFT: 'Draft',
  ARCHIVED: 'Archived',
};

export const LABEL_TYPES = {
  TEAMMATE: USER_PERMISSIONS.USER,
  ORG_ADMIN: USER_PERMISSIONS.ORGANISATION_ADMIN,
  CULTURE_PROJECT: PROJECT_TYPES.CULTURE_PROJECT,
  FEEDBACK_FRAMEWORK: PROJECT_TYPES.FEEDBACK_FRAMEWORK,
  PUBLIC_PROJECT: 'public_project',
  PRIVATE_PROJECT: 'private_project',
  PUBLIC_PROJECT_SHORT: 'public_project_short',
  PRIVATE_PROJECT_SHORT: 'private_project_short',
};

export const PROJECT_STATUS_TABS = {
  ACTIVE: 'Active',
  ARCHIVED: 'Archived',
};

export const SORTABLE_TABLE_COLUMN_TYPES = {
  NAME: 'name',
  TEXT: 'text',
  LABEL: 'label',
  REPORT_LINK: 'report_link',
  ACTIONS_MENU: 'actions_menu',
  ICONS_ACTIONS: 'icons_actions',
};

export const RESULT_PAGE_TYPES = {
  SUCCESS: 'success',
  ERROR: 'error',
  MESSAGE: 'message',
};

export const ACTION_MENU_BUTTON_TYPE = {
  ICON: 'icon',
  REGULAR: 'regular',
};

export const PROJECT_SCOPE_TABS = {
  ALL: 'All Projects',
  PERSONAL: 'Personal Projects',
};

export const INFO_BLOCK_TYPES = {
  INFO: 'info',
  ERROR: 'error',
  SUCCESS: 'success',
};

export const DATA_GRID_COLUMN_TYPE = {
  STRING: 'string',
  NUMBER: 'number',
  DATE: 'date',
  DATE_TIME: 'dateTime',
  BOOLEAN: 'boolean',
  SINGLE_SELECT: 'singleSelect',
  ACTIONS: 'actions',
};

export const SORTABLE_COLUMN_TYPES = [
  DATA_GRID_COLUMN_TYPE.STRING,
  DATA_GRID_COLUMN_TYPE.NUMBER,
  DATA_GRID_COLUMN_TYPE.DATE,
  DATA_GRID_COLUMN_TYPE.DATE_TIME,
  DATA_GRID_COLUMN_TYPE.BOOLEAN,
];

export const DATE_COLUMN_TYPES = [DATA_GRID_COLUMN_TYPE.DATE, DATA_GRID_COLUMN_TYPE.DATE_TIME];

export const FILTERABLE_COLUMN_TYPES = [DATA_GRID_COLUMN_TYPE.SINGLE_SELECT, DATA_GRID_COLUMN_TYPE.BOOLEAN];

export const DATA_GRID_FILTER_PANEL_TYPE = {
  SINGLE_SELECT: 'single_select',
  MULTIPLE_SELECT: 'multiple_select',
};

export const QR_ERROR_CORRECTION_LEVEL = {
  LOW: 'L',
  HIGH: 'H',
};

export const DATA_GROUP_ACTION_TYPES = {
  EDIT_BUTTON: 'editButton',
  FULL_ACTIONS: 'fullActions',
};

export const DATA_GRID_PAGE_SIZE_OPTIONS = {
  DEFAULT: [10, 20, 50],
  USERS: [20, 50, 100],
  SCROLLED_TABLE: [30],
  SCROLLABLE_PAGE: [10],
};

export const DATA_GRID_YES_NO_OPTIONS = {
  YES: 'Yes',
  NO: 'No',
};

export const tableYesNoOptions = [ALL_OPTIONS_VALUE, ...Object.values(DATA_GRID_YES_NO_OPTIONS)].map((value) => ({
  value,
  label: value === ALL_OPTIONS_VALUE ? 'All' : value,
}));
